export const selectIsFetching = state => state.bankDetail.isFetching
export const selectIsError = state => state.bankDetail.isError
export const selectIsLoaded = state => state.bankDetail.isLoaded
export const selectErrorMessage = state => state.bankDetail.errorMessage
export const selectBankDetails = state => state.bankDetail.bankDetails
